import React from "react";
import { Link } from "react-router-dom";
import LoungeLogo from "../../assets/img/loungelogo.png";

const WHATSAPP_LINK = "https://wa.me/+994705634333";

const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.068362395019!2d49.8295560741514!3d40.36851440102215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d007678141b%3A0xb0a32a8ffb78d915!2sFF%20QAD%C4%B0R%20LOUNGE!5e1!3m2!1saz!2saz!4v1731669353982!5m2!1saz!2saz";

const Lounge = () => {
  return (
    <main
      className="
        relative min-h-screen w-full overflow-x-hidden
        bg-[#f6f7fb]
        text-slate-900
        transition-colors duration-300
        dark:bg-[#05030a]
        dark:text-white
      "
    >
      {/* =====================================================
          BACKGROUND
      ===================================================== */}

      {/* Cyber grid */}
      <div
        className="
          pointer-events-none
          absolute inset-0
          opacity-30
          dark:opacity-[0.13]
        "
        style={{
          backgroundImage: `
            linear-gradient(rgba(139,92,246,0.08) 1px, transparent 1px),
            linear-gradient(90deg, rgba(34,211,238,0.08) 1px, transparent 1px)
          `,
          backgroundSize: "32px 32px",
        }}
      />

      {/* Purple ambient */}
      <div
        className="
          pointer-events-none
          absolute -left-32 top-16
          h-72 w-72
          rounded-full
          bg-purple-500/10
          blur-[110px]
          dark:bg-purple-600/15
        "
      />

      {/* Cyan ambient */}
      <div
        className="
          pointer-events-none
          absolute -right-32 top-[40%]
          h-72 w-72
          rounded-full
          bg-cyan-400/10
          blur-[110px]
          dark:bg-cyan-500/10
        "
      />

      {/* Gold ambient */}
      <div
        className="
          pointer-events-none
          absolute bottom-0 left-1/2
          h-64 w-64
          -translate-x-1/2
          rounded-full
          bg-[#d6b36a]/5
          blur-[110px]
          dark:bg-[#d6b36a]/10
        "
      />

      {/* =====================================================
          WHATSAPP BUTTON
      ===================================================== */}

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="
          group fixed
          bottom-4 right-4
          z-[100]
          flex
          h-12 w-12
          items-center justify-center
          rounded-full
          border
          border-white/20
          bg-[#25D366]
          text-white
          shadow-[0_0_22px_rgba(37,211,102,0.35)]
          transition-all duration-300
          hover:scale-110
          hover:shadow-[0_0_35px_rgba(37,211,102,0.65)]
          active:scale-95
          sm:bottom-5
          sm:right-5
          sm:h-14
          sm:w-14
        "
      >
        <svg
          viewBox="0 0 24 24"
          className="
            h-6 w-6
            fill-current
            transition-transform
            duration-300
            group-hover:scale-110
            sm:h-7 sm:w-7
          "
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.67-.51-.173-.008-.372-.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982 1-3.648-.235-.374a9.86 9.86 0 01-1.511-5.26c.001-5.45 4.437-9.884 9.89-9.884 2.64 0 5.122 1.03 6.987 2.898a9.825 9.825 0 012.893 6.994c-.002 5.45-4.437 9.884-9.887 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.946L.057 24l6.304-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 00-3.478-8.413" />
        </svg>
      </a>

      {/* =====================================================
          HERO / MENU AREA
      ===================================================== */}

      <section
        className="
          relative
          px-3
          pt-5
          sm:px-5
          sm:pt-7
          md:pt-10
        "
      >
        <div
          className="
            relative
            mx-auto
            max-w-7xl
            overflow-hidden
            rounded-[22px]
            border
            border-slate-200
            bg-white/70
            px-4
            py-5
            shadow-[0_20px_60px_rgba(15,23,42,0.06)]
            backdrop-blur-xl
            dark:border-white/[0.05]
            dark:bg-[#090611]
            dark:shadow-[0_25px_70px_rgba(0,0,0,0.45)]
            sm:rounded-[28px]
            sm:px-7
            sm:py-7
            md:px-10
            md:py-9
          "
        >
          {/* Top neon line */}
          <div
            className="
              absolute left-0 right-0 top-0
              h-px
              bg-gradient-to-r
              from-transparent
              via-purple-500/60
              to-transparent
            "
          />

          {/* Decorative glow */}
          <div
            className="
              pointer-events-none
              absolute left-1/2 top-0
              h-28 w-72
              -translate-x-1/2
              rounded-full
              bg-purple-500/5
              blur-3xl
              dark:bg-purple-500/10
            "
          />

          {/* =================================================
              SMALL TOP LABEL
          ================================================= */}

          <div className="relative z-10 mb-4 text-center sm:mb-5">
            <div
              className="
                inline-flex
                items-center
                gap-2
                rounded-full
                border
                border-[#d6b36a]/20
                bg-[#d6b36a]/5
                px-3 py-1
                text-[8px]
                font-bold
                uppercase
                tracking-[0.25em]
                text-[#9b7836]
                dark:border-[#d6b36a]/20
                dark:bg-[#d6b36a]/5
                dark:text-[#d6b36a]
                sm:px-4
                sm:py-1.5
                sm:text-[9px]
              "
            >
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 shadow-[0_0_9px_rgba(52,211,153,0.8)]" />
              FF QADİR LOUNGE
            </div>
          </div>

          {/* =================================================
              NEW MENU BUTTON
          ================================================= */}

          <div className="relative z-10 flex justify-center">
            <Link
              to="/Menyu"
              className="
                group
                relative
                inline-flex
                items-center
                gap-3
                overflow-hidden
                rounded-2xl
                border
                border-purple-500/20
                bg-slate-50/80
                px-4
                py-2.5
                shadow-[0_10px_30px_rgba(139,92,246,0.06)]
                transition-all
                duration-300
                hover:-translate-y-1
                hover:border-purple-500/40
                hover:shadow-[0_15px_40px_rgba(139,92,246,0.16)]
                dark:border-purple-500/20
                dark:bg-[#0d0915]
                dark:shadow-[0_10px_35px_rgba(0,0,0,0.35)]
                dark:hover:border-purple-500/40
                dark:hover:shadow-[0_15px_45px_rgba(139,92,246,0.14)]
                sm:gap-4
                sm:px-5
                sm:py-3
              "
            >
              {/* Shine */}
              <span
                className="
                  absolute
                  inset-y-0
                  -left-full
                  w-1/3
                  skew-x-[-20deg]
                  bg-white/10
                  transition-all
                  duration-700
                  group-hover:left-[120%]
                "
              />

              {/* Icon */}
              <span
                className="
                  relative
                  flex
                  h-9 w-9
                  items-center
                  justify-center
                  rounded-xl
                  border
                  border-purple-500/20
                  bg-purple-500/10
                  text-purple-500
                  transition-all
                  duration-300
                  group-hover:scale-105
                  group-hover:rotate-3
                  dark:border-purple-500/25
                  dark:bg-purple-500/10
                  dark:text-purple-300
                  sm:h-10
                  sm:w-10
                "
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-5 w-5"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7a2.5 2.5 0 0 1-2.5 2.5H11l-4.5 3v-3h0A2.5 2.5 0 0 1 4 13.5v-7Z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8 8h8M8 11h5"
                  />
                </svg>
              </span>

              {/* Text */}
              <span className="relative text-left">
                <span
                  className="
                    block
                    text-[8px]
                    font-bold
                    uppercase
                    tracking-[0.2em]
                    text-slate-400
                    dark:text-white/30
                  "
                >
                  FF QADİR
                </span>

                <span
                  className="
                    mt-0.5
                    block
                    text-sm
                    font-black
                    tracking-wide
                    text-slate-800
                    dark:text-white
                    sm:text-base
                  "
                >
                  MENYUYA BAX
                </span>
              </span>

              {/* Arrow */}
              <span
                className="
                  relative
                  ml-1
                  flex
                  h-7 w-7
                  items-center
                  justify-center
                  rounded-full
                  bg-purple-500/5
                  text-purple-500
                  transition-transform
                  duration-300
                  group-hover:translate-x-1
                  dark:bg-purple-500/10
                  dark:text-purple-300
                "
              >
                →
              </span>
            </Link>
          </div>

          {/* Menu description */}
          <p
            className="
              relative
              z-10
              mx-auto
              mt-3
              max-w-sm
              text-center
              text-[9px]
              leading-4
              text-slate-400
              dark:text-white/30
              sm:text-[10px]
            "
          >
            Lounge menyusunu kəşf et və sevdiyin seçimlərə nəzər sal.
          </p>

          {/* =================================================
              MINI DECORATION
          ================================================= */}

          <div className="relative z-10 mx-auto mt-5 flex max-w-[260px] items-center justify-center gap-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-purple-500/20" />

            <div className="h-1.5 w-1.5 rotate-45 bg-[#d6b36a]/70" />

            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-cyan-500/20" />
          </div>
        </div>
      </section>

      {/* =====================================================
          LOGO + MAP
      ===================================================== */}

      <section
        className="
          relative
          mx-auto
          w-full
          max-w-7xl
          px-3
          py-6
          sm:px-5
          sm:py-9
          md:px-7
          md:py-12
        "
      >
        <div
          className="
            grid
            grid-cols-1
            gap-4
            lg:grid-cols-3
            lg:gap-5
          "
        >
          {/* =================================================
              LOGO CARD
          ================================================= */}

          <div
            className="
              group
              relative
              overflow-hidden
              rounded-[22px]
              border
              border-slate-200
              bg-white/70
              p-4
              shadow-[0_20px_60px_rgba(15,23,42,0.06)]
              backdrop-blur-xl
              dark:border-white/[0.05]
              dark:bg-[#090611]
              dark:shadow-[0_25px_70px_rgba(0,0,0,0.45)]
              sm:rounded-[26px]
              sm:p-6
              lg:col-span-2
            "
          >
            {/* Top line */}
            <div
              className="
                absolute left-0 right-0 top-0
                h-px
                bg-gradient-to-r
                from-transparent
                via-[#d6b36a]/50
                to-transparent
              "
            />

            {/* Logo glow */}
            <div
              className="
                pointer-events-none
                absolute left-1/2 top-1/2
                h-44 w-44
                -translate-x-1/2
                -translate-y-1/2
                rounded-full
                bg-purple-500/5
                blur-[70px]
                transition-all
                duration-500
                group-hover:bg-purple-500/10
                dark:bg-purple-500/10
              "
            />

            <div className="relative flex h-full min-h-[245px] flex-col items-center justify-center sm:min-h-[300px]">
              {/* Small label */}
              <div
                className="
                  mb-3
                  flex
                  items-center
                  gap-2
                  text-[8px]
                  font-bold
                  uppercase
                  tracking-[0.25em]
                  text-slate-400
                  dark:text-white/25
                "
              >
                <span className="h-px w-5 bg-purple-500/30" />
                LOUNGE
                <span className="h-px w-5 bg-cyan-500/30" />
              </div>

              {/* Logo */}
              <img
                src={LoungeLogo}
                alt="FF Qadir Lounge Logo"
                className="
                  mx-auto
                  block
                  h-auto
                  w-full
                  max-w-[430px]
                  object-contain
                  transition-transform
                  duration-500
                  group-hover:scale-[1.02]
                "
              />

              {/* Description */}
              <p
                className="
                  mt-3
                  text-center
                  text-xs
                  font-semibold
                  tracking-wide
                  text-slate-500
                  dark:text-white/40
                  sm:mt-5
                  sm:text-sm
                "
              >
                Münasib qiymət, yüksək keyfiyyət!
              </p>

              {/* Gold line */}
              <div className="mt-3 flex items-center gap-2">
                <div className="h-px w-8 bg-gradient-to-r from-transparent to-[#d6b36a]/50" />

                <span className="text-[9px] text-[#d6b36a]">✦</span>

                <div className="h-px w-8 bg-gradient-to-l from-transparent to-[#d6b36a]/50" />
              </div>
            </div>
          </div>

          {/* =================================================
              MAP CARD
          ================================================= */}

          <div
            className="
              relative
              overflow-hidden
              rounded-[22px]
              border
              border-slate-200
              bg-white/70
              p-1.5
              shadow-[0_20px_60px_rgba(15,23,42,0.06)]
              backdrop-blur-xl
              dark:border-white/[0.05]
              dark:bg-[#090611]
              dark:shadow-[0_25px_70px_rgba(0,0,0,0.45)]
              sm:rounded-[26px]
              sm:p-2
            "
          >
            {/* Map label */}
            <div
              className="
                absolute
                left-3
                top-3
                z-10
                flex
                items-center
                gap-1.5
                rounded-full
                border
                border-white/20
                bg-black/60
                px-2.5
                py-1.5
                text-[8px]
                font-bold
                text-white
                shadow-lg
                backdrop-blur-md
              "
            >
              <span className="h-1.5 w-1.5 rounded-full bg-red-400 shadow-[0_0_8px_rgba(248,113,113,0.8)]" />
              FF QADİR LOUNGE
            </div>

            <div
              className="
                overflow-hidden
                rounded-[17px]
                border
                border-slate-200
                dark:border-white/[0.05]
              "
            >
              <iframe
                title="FF Qadir Lounge xəritəsi"
                src={MAP_URL}
                className="
                  block
                  h-[230px]
                  w-full
                  border-0
                  sm:h-[280px]
                  lg:h-[310px]
                "
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* Address bottom */}
            <div className="px-2 py-2 sm:px-3 sm:py-2.5">
              <div className="flex items-center gap-2">
                <span className="text-sm">📍</span>

                <div>
                  <p
                    className="
                      text-[9px]
                      font-bold
                      text-slate-700
                      dark:text-white/70
                      sm:text-[10px]
                    "
                  >
                    FF QADİR LOUNGE
                  </p>

                  <p
                    className="
                      text-[8px]
                      text-slate-400
                      dark:text-white/25
                      sm:text-[9px]
                    "
                  >
                    Xəritədə məkana bax
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          BOTTOM CTA
      ===================================================== */}

      <section className="relative px-3 pb-6 sm:px-5 sm:pb-8">
        <div
          className="
            mx-auto
            max-w-xl
            rounded-[18px]
            border
            border-slate-200
            bg-white/60
            px-4
            py-4
            text-center
            shadow-[0_15px_40px_rgba(15,23,42,0.05)]
            backdrop-blur-xl
            dark:border-white/[0.04]
            dark:bg-[#090611]
            dark:shadow-[0_20px_50px_rgba(0,0,0,0.4)]
            sm:rounded-[22px]
            sm:px-6
          "
        >
          <div className="flex items-center justify-center gap-2">
            <span
              className="
                flex
                h-7 w-7
                items-center justify-center
                rounded-lg
                border
                border-[#d6b36a]/20
                bg-[#d6b36a]/10
                text-xs
              "
            >
              ✦
            </span>

            <div className="text-left">
              <p
                className="
                  text-[10px]
                  font-bold
                  text-slate-800
                  dark:text-white/75
                  sm:text-xs
                "
              >
                Lounge-da görüşmək ümidi ilə!
              </p>

              <p
                className="
                  mt-0.5
                  text-[8px]
                  text-slate-400
                  dark:text-white/25
                  sm:text-[9px]
                "
              >
                Sizi FF QADİR LOUNGE-da gözləyirik.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          FOOTER
      ===================================================== */}

      <footer
        className="
          border-t
          border-slate-200
          bg-white/40
          px-4
          py-4
          text-center
          dark:border-white/[0.04]
          dark:bg-[#040207]
          sm:py-5
        "
      >
        <div className="flex items-center justify-center gap-2">
          <span className="h-px w-5 bg-gradient-to-r from-transparent to-purple-500/30" />

          <p
            className="
              text-[9px]
              text-slate-400
              dark:text-white/25
              sm:text-[10px]
            "
          >
            © {new Date().getFullYear()} FF Qadir Lounge
          </p>

          <span className="h-px w-5 bg-gradient-to-l from-transparent to-cyan-500/30" />
        </div>
      </footer>
    </main>
  );
};

export default Lounge;